/**

Adapted from jackocnr / intl-tel-input (github)
https://github.com/jackocnr/intl-tel-input/blob/master/src/js/data.js

The MIT License (MIT)

Copyright (c) 2014-2016 Jack O'Connor

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.

*/

let countryPhone = [
  {
    name: 'Afghanistan (‫افغانستان‬‎)',
    iso: 'AF',
    dialCode: '93',
    typeahead: 'Afghanistan (‫افغانستان‬‎) +93'
  },
  {
    name: 'Albania (Shqipëri)',
    iso: 'AL',
    dialCode: '355',
    typeahead: 'Albania (Shqipëri) +355'
  },
  {
    name: 'Algeria (‫الجزائر‬‎)',
    iso: 'DZ',
    dialCode: '213',
    typeahead: 'Algeria (‫الجزائر‬‎) +213'
  },
  {
    name: 'American Samoa',
    iso: 'AS',
    dialCode: '1',
    typeahead: 'American Samoa +1'
  },
  {
    name: 'Andorra',
    iso: 'AD',
    dialCode: '376',
    typeahead: 'Andorra +376'
  },
  {
    name: 'Angola',
    iso: 'AO',
    dialCode: '244',
    typeahead: 'Angola +244'
  },
  {
    name: 'Anguilla',
    iso: 'AI',
    dialCode: '1',
    typeahead: 'Anguilla +1'
  },
  {
    name: 'Antigua and Barbuda',
    iso: 'AG',
    dialCode: '1',
    typeahead: 'Antigua and Barbuda +1'
  },
  {
    name: 'Argentina',
    iso: 'AR',
    dialCode: '54',
    typeahead: 'Argentina +54'
  },
  {
    name: 'Armenia (Հայաստան)',
    iso: 'AM',
    dialCode: '374',
    typeahead: 'Armenia (Հայաստան) +374'
  },
  {
    name: 'Aruba',
    iso: 'AW',
    dialCode: '297',
    typeahead: 'Aruba +297'
  },
  {
    name: 'Ascension Island',
    iso: 'AC',
    dialCode: '247',
    typeahead: 'Ascension Island +247'
  },
  {
    name: 'Australia',
    iso: 'AU',
    dialCode: '61',
    typeahead: 'Australia +61'
  },
  {
    name: 'Austria (Österreich)',
    iso: 'AT',
    dialCode: '43',
    typeahead: 'Austria (Österreich) +43'
  },
  {
    name: 'Azerbaijan (Azərbaycan)',
    iso: 'AZ',
    dialCode: '994',
    typeahead: 'Azerbaijan (Azərbaycan) +994'
  },
  {
    name: 'Bahamas',
    iso: 'BS',
    dialCode: '1',
    typeahead: 'Bahamas +1'
  },
  {
    name: 'Bahrain (‫البحرين‬‎)',
    iso: 'BH',
    dialCode: '973',
    typeahead: 'Bahrain (‫البحرين‬‎) +973'
  },
  {
    name: 'Bangladesh (বাংলাদেশ)',
    iso: 'BD',
    dialCode: '880',
    typeahead: 'Bangladesh (বাংলাদেশ) +880'
  },
  {
    name: 'Barbados',
    iso: 'BB',
    dialCode: '1',
    typeahead: 'Barbados +1'
  },
  {
    name: 'Belarus (Беларусь)',
    iso: 'BY',
    dialCode: '375',
    typeahead: 'Belarus (Беларусь) +375'
  },
  {
    name: 'Belgium (België)',
    iso: 'BE',
    dialCode: '32',
    typeahead: 'Belgium (België) +32'
  },
  {
    name: 'Belize',
    iso: 'BZ',
    dialCode: '501',
    typeahead: 'Belize +501'
  },
  {
    name: 'Benin (Bénin)',
    iso: 'BJ',
    dialCode: '229',
    typeahead: 'Benin (Bénin) +229'
  },
  {
    name: 'Bermuda',
    iso: 'BM',
    dialCode: '1',
    typeahead: 'Bermuda +1'
  },
  {
    name: 'Bhutan (འབྲུག)',
    iso: 'BT',
    dialCode: '975',
    typeahead: 'Bhutan (འབྲུག) +975'
  },
  {
    name: 'Bolivia',
    iso: 'BO',
    dialCode: '591',
    typeahead: 'Bolivia +591'
  },
  {
    name: 'Bosnia and Herzegovina (Босна и Херцеговина)',
    iso: 'BA',
    dialCode: '387',
    typeahead: 'Bosnia and Herzegovina (Босна и Херцеговина) +387'
  },
  {
    name: 'Botswana',
    iso: 'BW',
    dialCode: '267',
    typeahead: 'Botswana +267'
  },
  {
    name: 'Brazil (Brasil)',
    iso: 'BR',
    dialCode: '55',
    typeahead: 'Brazil (Brasil) +55'
  },
  {
    name: 'British Indian Ocean Territory',
    iso: 'IO',
    dialCode: '246',
    typeahead: 'British Indian Ocean Territory +246'
  },
  {
    name: 'British Virgin Islands',
    iso: 'VG',
    dialCode: '1',
    typeahead: 'British Virgin Islands +1'
  },
  {
    name: 'Brunei',
    iso: 'BN',
    dialCode: '673',
    typeahead: 'Brunei +673'
  },
  {
    name: 'Bulgaria (България)',
    iso: 'BG',
    dialCode: '359',
    typeahead: 'Bulgaria (България) +359'
  },
  {
    name: 'Burkina Faso',
    iso: 'BF',
    dialCode: '226',
    typeahead: 'Burkina Faso +226'
  },
  {
    name: 'Burundi (Uburundi)',
    iso: 'BI',
    dialCode: '257',
    typeahead: 'Burundi (Uburundi) +257'
  },
  {
    name: 'Cambodia (កម្ពុជា)',
    iso: 'KH',
    dialCode: '855',
    typeahead: 'Cambodia (កម្ពុជា) +855'
  },
  {
    name: 'Cameroon (Cameroun)',
    iso: 'CM',
    dialCode: '237',
    typeahead: 'Cameroon (Cameroun) +237'
  },
  {
    name: 'Canada',
    iso: 'CA',
    dialCode: '1',
    typeahead: 'Canada +1'
  },
  {
    name: 'Cape Verde (Kabu Verdi)',
    iso: 'CV',
    dialCode: '238',
    typeahead: 'Cape Verde (Kabu Verdi) +238'
  },
  {
    name: 'Caribbean Netherlands',
    iso: 'BQ',
    dialCode: '599',
    typeahead: 'Caribbean Netherlands +599'
  },
  {
    name: 'Cayman Islands',
    iso: 'KY',
    dialCode: '1',
    typeahead: 'Cayman Islands +1'
  },
  {
    name: 'Central African Republic (République centrafricaine)',
    iso: 'CF',
    dialCode: '236',
    typeahead: 'Central African Republic (République centrafricaine) +236'
  },
  {
    name: 'Chad (Tchad)',
    iso: 'TD',
    dialCode: '235',
    typeahead: 'Chad (Tchad) +235'
  },
  {
    name: 'Chile',
    iso: 'CL',
    dialCode: '56',
    typeahead: 'Chile +56'
  },
  {
    name: 'China (中国)',
    iso: 'CN',
    dialCode: '86',
    typeahead: 'China (中国) +86'
  },
  {
    name: 'Christmas Island',
    iso: 'CX',
    dialCode: '61',
    typeahead: 'Christmas Island +61'
  },
  {
    name: 'Cocos (Keeling) Islands',
    iso: 'CC',
    dialCode: '61',
    typeahead: 'Cocos (Keeling) Islands +61'
  },
  {
    name: 'Colombia',
    iso: 'CO',
    dialCode: '57',
    typeahead: 'Colombia +57'
  },
  {
    name: 'Comoros (‫جزر القمر‬‎)',
    iso: 'KM',
    dialCode: '269',
    typeahead: 'Comoros (‫جزر القمر‬‎) +269'
  },
  {
    name: 'Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)',
    iso: 'CD',
    dialCode: '243',
    typeahead: 'Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo) +243'
  },
  {
    name: 'Congo (Republic) (Congo-Brazzaville)',
    iso: 'CG',
    dialCode: '242',
    typeahead: 'Congo (Republic) (Congo-Brazzaville) +242'
  },
  {
    name: 'Cook Islands',
    iso: 'CK',
    dialCode: '682',
    typeahead: 'Cook Islands +682'
  },
  {
    name: 'Costa Rica',
    iso: 'CR',
    dialCode: '506',
    typeahead: 'Costa Rica +506'
  },
  {
    name: 'Côte d’Ivoire',
    iso: 'CI',
    dialCode: '225',
    typeahead: 'Côte d’Ivoire +225'
  },
  {
    name: 'Croatia (Hrvatska)',
    iso: 'HR',
    dialCode: '385',
    typeahead: 'Croatia (Hrvatska) +385'
  },
  {
    name: 'Cuba',
    iso: 'CU',
    dialCode: '53',
    typeahead: 'Cuba +53'
  },
  {
    name: 'Curaçao',
    iso: 'CW',
    dialCode: '599',
    typeahead: 'Curaçao +599'
  },
  {
    name: 'Cyprus (Κύπρος)',
    iso: 'CY',
    dialCode: '357',
    typeahead: 'Cyprus (Κύπρος) +357'
  },
  {
    name: 'Czech Republic (Česká republika)',
    iso: 'CZ',
    dialCode: '420',
    typeahead: 'Czech Republic (Česká republika) +420'
  },
  {
    name: 'Denmark (Danmark)',
    iso: 'DK',
    dialCode: '45',
    typeahead: 'Denmark (Danmark) +45'
  },
  {
    name: 'Djibouti',
    iso: 'DJ',
    dialCode: '253',
    typeahead: 'Djibouti +253'
  },
  {
    name: 'Dominica',
    iso: 'DM',
    dialCode: '1',
    typeahead: 'Dominica +1'
  },
  {
    name: 'Dominican Republic (República Dominicana)',
    iso: 'DO',
    dialCode: '1',
    typeahead: 'Dominican Republic (República Dominicana) +1'
  },
  {
    name: 'Ecuador',
    iso: 'EC',
    dialCode: '593',
    typeahead: 'Ecuador +593'
  },
  {
    name: 'Egypt (‫مصر‬‎)',
    iso: 'EG',
    dialCode: '20',
    typeahead: 'Egypt (‫مصر‬‎) +20'
  },
  {
    name: 'El Salvador',
    iso: 'SV',
    dialCode: '503',
    typeahead: 'El Salvador +503'
  },
  {
    name: 'Equatorial Guinea (Guinea Ecuatorial)',
    iso: 'GQ',
    dialCode: '240',
    typeahead: 'Equatorial Guinea (Guinea Ecuatorial) +240'
  },
  {
    name: 'Eritrea',
    iso: 'ER',
    dialCode: '291',
    typeahead: 'Eritrea +291'
  },
  {
    name: 'Estonia (Eesti)',
    iso: 'EE',
    dialCode: '372',
    typeahead: 'Estonia (Eesti) +372'
  },
  {
    name: 'Eswatini',
    iso: 'SZ',
    dialCode: '268',
    typeahead: 'Eswatini +268'
  },
  {
    name: 'Ethiopia',
    iso: 'ET',
    dialCode: '251',
    typeahead: 'Ethiopia +251'
  },
  {
    name: 'Falkland Islands (Islas Malvinas)',
    iso: 'FK',
    dialCode: '500',
    typeahead: 'Falkland Islands (Islas Malvinas) +500'
  },
  {
    name: 'Faroe Islands (Føroyar)',
    iso: 'FO',
    dialCode: '298',
    typeahead: 'Faroe Islands (Føroyar) +298'
  },
  {
    name: 'Fiji',
    iso: 'FJ',
    dialCode: '679',
    typeahead: 'Fiji +679'
  },
  {
    name: 'Finland (Suomi)',
    iso: 'FI',
    dialCode: '358',
    typeahead: 'Finland (Suomi) +358'
  },
  {
    name: 'France',
    iso: 'FR',
    dialCode: '33',
    typeahead: 'France +33'
  },
  {
    name: 'French Guiana (Guyane française)',
    iso: 'GF',
    dialCode: '594',
    typeahead: 'French Guiana (Guyane française) +594'
  },
  {
    name: 'French Polynesia (Polynésie française)',
    iso: 'PF',
    dialCode: '689',
    typeahead: 'French Polynesia (Polynésie française) +689'
  },
  {
    name: 'Gabon',
    iso: 'GA',
    dialCode: '241',
    typeahead: 'Gabon +241'
  },
  {
    name: 'Gambia',
    iso: 'GM',
    dialCode: '220',
    typeahead: 'Gambia +220'
  },
  {
    name: 'Georgia (საქართველო)',
    iso: 'GE',
    dialCode: '995',
    typeahead: 'Georgia (საქართველო) +995'
  },
  {
    name: 'Germany (Deutschland)',
    iso: 'DE',
    dialCode: '49',
    typeahead: 'Germany (Deutschland) +49'
  },
  {
    name: 'Ghana (Gaana)',
    iso: 'GH',
    dialCode: '233',
    typeahead: 'Ghana (Gaana) +233'
  },
  {
    name: 'Gibraltar',
    iso: 'GI',
    dialCode: '350',
    typeahead: 'Gibraltar +350'
  },
  {
    name: 'Greece (Ελλάδα)',
    iso: 'GR',
    dialCode: '30',
    typeahead: 'Greece (Ελλάδα) +30'
  },
  {
    name: 'Greenland (Kalaallit Nunaat)',
    iso: 'GL',
    dialCode: '299',
    typeahead: 'Greenland (Kalaallit Nunaat) +299'
  },
  {
    name: 'Grenada',
    iso: 'GD',
    dialCode: '1',
    typeahead: 'Grenada +1'
  },
  {
    name: 'Guadeloupe',
    iso: 'GP',
    dialCode: '590',
    typeahead: 'Guadeloupe +590'
  },
  {
    name: 'Guam',
    iso: 'GU',
    dialCode: '1',
    typeahead: 'Guam +1'
  },
  {
    name: 'Guatemala',
    iso: 'GT',
    dialCode: '502',
    typeahead: 'Guatemala +502'
  },
  {
    name: 'Guernsey',
    iso: 'GG',
    dialCode: '44',
    typeahead: 'Guernsey +44'
  },
  {
    name: 'Guinea (Guinée)',
    iso: 'GN',
    dialCode: '224',
    typeahead: 'Guinea (Guinée) +224'
  },
  {
    name: 'Guinea-Bissau (Guiné Bissau)',
    iso: 'GW',
    dialCode: '245',
    typeahead: 'Guinea-Bissau (Guiné Bissau) +245'
  },
  {
    name: 'Guyana',
    iso: 'GY',
    dialCode: '592',
    typeahead: 'Guyana +592'
  },
  {
    name: 'Haiti',
    iso: 'HT',
    dialCode: '509',
    typeahead: 'Haiti +509'
  },
  {
    name: 'Honduras',
    iso: 'HN',
    dialCode: '504',
    typeahead: 'Honduras +504'
  },
  {
    name: 'Hong Kong (香港)',
    iso: 'HK',
    dialCode: '852',
    typeahead: 'Hong Kong (香港) +852'
  },
  {
    name: 'Hungary (Magyarország)',
    iso: 'HU',
    dialCode: '36',
    typeahead: 'Hungary (Magyarország) +36'
  },
  {
    name: 'Iceland (Ísland)',
    iso: 'IS',
    dialCode: '354',
    typeahead: 'Iceland (Ísland) +354'
  },
  {
    name: 'India (भारत)',
    iso: 'IN',
    dialCode: '91',
    typeahead: 'India (भारत) +91'
  },
  {
    name: 'Indonesia',
    iso: 'ID',
    dialCode: '62',
    typeahead: 'Indonesia +62'
  },
  {
    name: 'Iran (‫ایران‬‎)',
    iso: 'IR',
    dialCode: '98',
    typeahead: 'Iran (‫ایران‬‎) +98'
  },
  {
    name: 'Iraq (‫العراق‬‎)',
    iso: 'IQ',
    dialCode: '964',
    typeahead: 'Iraq (‫العراق‬‎) +964'
  },
  {
    name: 'Ireland',
    iso: 'IE',
    dialCode: '353',
    typeahead: 'Ireland +353'
  },
  {
    name: 'Isle of Man',
    iso: 'IM',
    dialCode: '44',
    typeahead: 'Isle of Man +44'
  },
  {
    name: 'Israel (‫ישראל‬‎)',
    iso: 'IL',
    dialCode: '972',
    typeahead: 'Israel (‫ישראל‬‎) +972'
  },
  {
    name: 'Italy (Italia)',
    iso: 'IT',
    dialCode: '39',
    typeahead: 'Italy (Italia) +39'
  },
  {
    name: 'Jamaica',
    iso: 'JM',
    dialCode: '1',
    typeahead: 'Jamaica +1'
  },
  {
    name: 'Japan (日本)',
    iso: 'JP',
    dialCode: '81',
    typeahead: 'Japan (日本) +81'
  },
  {
    name: 'Jersey',
    iso: 'JE',
    dialCode: '44',
    typeahead: 'Jersey +44'
  },
  {
    name: 'Jordan (‫الأردن‬‎)',
    iso: 'JO',
    dialCode: '962',
    typeahead: 'Jordan (‫الأردن‬‎) +962'
  },
  {
    name: 'Kazakhstan (Казахстан)',
    iso: 'KZ',
    dialCode: '7',
    typeahead: 'Kazakhstan (Казахстан) +7'
  },
  {
    name: 'Kenya',
    iso: 'KE',
    dialCode: '254',
    typeahead: 'Kenya +254'
  },
  {
    name: 'Kiribati',
    iso: 'KI',
    dialCode: '686',
    typeahead: 'Kiribati +686'
  },
  {
    name: 'Kosovo',
    iso: 'XK',
    dialCode: '383',
    typeahead: 'Kosovo +383'
  },
  {
    name: 'Kuwait (‫الكويت‬‎)',
    iso: 'KW',
    dialCode: '965',
    typeahead: 'Kuwait (‫الكويت‬‎) +965'
  },
  {
    name: 'Kyrgyzstan (Кыргызстан)',
    iso: 'KG',
    dialCode: '996',
    typeahead: 'Kyrgyzstan (Кыргызстан) +996'
  },
  {
    name: 'Laos (ລາວ)',
    iso: 'LA',
    dialCode: '856',
    typeahead: 'Laos (ລາວ) +856'
  },
  {
    name: 'Latvia (Latvija)',
    iso: 'LV',
    dialCode: '371',
    typeahead: 'Latvia (Latvija) +371'
  },
  {
    name: 'Lebanon (‫لبنان‬‎)',
    iso: 'LB',
    dialCode: '961',
    typeahead: 'Lebanon (‫لبنان‬‎) +961'
  },
  {
    name: 'Lesotho',
    iso: 'LS',
    dialCode: '266',
    typeahead: 'Lesotho +266'
  },
  {
    name: 'Liberia',
    iso: 'LR',
    dialCode: '231',
    typeahead: 'Liberia +231'
  },
  {
    name: 'Libya (‫ليبيا‬‎)',
    iso: 'LY',
    dialCode: '218',
    typeahead: 'Libya (‫ليبيا‬‎) +218'
  },
  {
    name: 'Liechtenstein',
    iso: 'LI',
    dialCode: '423',
    typeahead: 'Liechtenstein +423'
  },
  {
    name: 'Lithuania (Lietuva)',
    iso: 'LT',
    dialCode: '370',
    typeahead: 'Lithuania (Lietuva) +370'
  },
  {
    name: 'Luxembourg',
    iso: 'LU',
    dialCode: '352',
    typeahead: 'Luxembourg +352'
  },
  {
    name: 'Macau (澳門)',
    iso: 'MO',
    dialCode: '853',
    typeahead: 'Macau (澳門) +853'
  },
  {
    name: 'Macedonia (FYROM) (Македонија)',
    iso: 'MK',
    dialCode: '389',
    typeahead: 'Macedonia (FYROM) (Македонија) +389'
  },
  {
    name: 'Madagascar (Madagasikara)',
    iso: 'MG',
    dialCode: '261',
    typeahead: 'Madagascar (Madagasikara) +261'
  },
  {
    name: 'Malawi',
    iso: 'MW',
    dialCode: '265',
    typeahead: 'Malawi +265'
  },
  {
    name: 'Malaysia',
    iso: 'MY',
    dialCode: '60',
    typeahead: 'Malaysia +60'
  },
  {
    name: 'Maldives',
    iso: 'MV',
    dialCode: '960',
    typeahead: 'Maldives +960'
  },
  {
    name: 'Mali',
    iso: 'ML',
    dialCode: '223',
    typeahead: 'Mali +223'
  },
  {
    name: 'Malta',
    iso: 'MT',
    dialCode: '356',
    typeahead: 'Malta +356'
  },
  {
    name: 'Marshall Islands',
    iso: 'MH',
    dialCode: '692',
    typeahead: 'Marshall Islands +692'
  },
  {
    name: 'Martinique',
    iso: 'MQ',
    dialCode: '596',
    typeahead: 'Martinique +596'
  },
  {
    name: 'Mauritania (‫موريتانيا‬‎)',
    iso: 'MR',
    dialCode: '222',
    typeahead: 'Mauritania (‫موريتانيا‬‎) +222'
  },
  {
    name: 'Mauritius (Moris)',
    iso: 'MU',
    dialCode: '230',
    typeahead: 'Mauritius (Moris) +230'
  },
  {
    name: 'Mayotte',
    iso: 'YT',
    dialCode: '262',
    typeahead: 'Mayotte +262'
  },
  {
    name: 'Mexico (México)',
    iso: 'MX',
    dialCode: '52',
    typeahead: 'Mexico (México) +52'
  },
  {
    name: 'Micronesia',
    iso: 'FM',
    dialCode: '691',
    typeahead: 'Micronesia +691'
  },
  {
    name: 'Moldova (Republica Moldova)',
    iso: 'MD',
    dialCode: '373',
    typeahead: 'Moldova (Republica Moldova) +373'
  },
  {
    name: 'Monaco',
    iso: 'MC',
    dialCode: '377',
    typeahead: 'Monaco +377'
  },
  {
    name: 'Mongolia (Монгол)',
    iso: 'MN',
    dialCode: '976',
    typeahead: 'Mongolia (Монгол) +976'
  },
  {
    name: 'Montenegro (Crna Gora)',
    iso: 'ME',
    dialCode: '382',
    typeahead: 'Montenegro (Crna Gora) +382'
  },
  {
    name: 'Montserrat',
    iso: 'MS',
    dialCode: '1',
    typeahead: 'Montserrat +1'
  },
  {
    name: 'Morocco (‫المغرب‬‎)',
    iso: 'MA',
    dialCode: '212',
    typeahead: 'Morocco (‫المغرب‬‎) +212'
  },
  {
    name: 'Mozambique (Moçambique)',
    iso: 'MZ',
    dialCode: '258',
    typeahead: 'Mozambique (Moçambique) +258'
  },
  {
    name: 'Myanmar (Burma) (မြန်မာ)',
    iso: 'MM',
    dialCode: '95',
    typeahead: 'Myanmar (Burma) (မြန်မာ) +95'
  },
  {
    name: 'Namibia (Namibië)',
    iso: 'NA',
    dialCode: '264',
    typeahead: 'Namibia (Namibië) +264'
  },
  {
    name: 'Nauru',
    iso: 'NR',
    dialCode: '674',
    typeahead: 'Nauru +674'
  },
  {
    name: 'Nepal (नेपाल)',
    iso: 'NP',
    dialCode: '977',
    typeahead: 'Nepal (नेपाल) +977'
  },
  {
    name: 'Netherlands (Nederland)',
    iso: 'NL',
    dialCode: '31',
    typeahead: 'Netherlands (Nederland) +31'
  },
  {
    name: 'New Caledonia (Nouvelle-Calédonie)',
    iso: 'NC',
    dialCode: '687',
    typeahead: 'New Caledonia (Nouvelle-Calédonie) +687'
  },
  {
    name: 'New Zealand',
    iso: 'NZ',
    dialCode: '64',
    typeahead: 'New Zealand +64'
  },
  {
    name: 'Nicaragua',
    iso: 'NI',
    dialCode: '505',
    typeahead: 'Nicaragua +505'
  },
  {
    name: 'Niger (Nijar)',
    iso: 'NE',
    dialCode: '227',
    typeahead: 'Niger (Nijar) +227'
  },
  {
    name: 'Nigeria',
    iso: 'NG',
    dialCode: '234',
    typeahead: 'Nigeria +234'
  },
  {
    name: 'Niue',
    iso: 'NU',
    dialCode: '683',
    typeahead: 'Niue +683'
  },
  {
    name: 'Norfolk Island',
    iso: 'NF',
    dialCode: '672',
    typeahead: 'Norfolk Island +672'
  },
  {
    name: 'North Korea (조선 민주주의 인민 공화국)',
    iso: 'KP',
    dialCode: '850',
    typeahead: 'North Korea (조선 민주주의 인민 공화국) +850'
  },
  {
    name: 'Northern Mariana Islands',
    iso: 'MP',
    dialCode: '1',
    typeahead: 'Northern Mariana Islands +1'
  },
  {
    name: 'Norway (Norge)',
    iso: 'NO',
    dialCode: '47',
    typeahead: 'Norway (Norge) +47'
  },
  {
    name: 'Oman (‫عُمان‬‎)',
    iso: 'OM',
    dialCode: '968',
    typeahead: 'Oman (‫عُمان‬‎) +968'
  },
  {
    name: 'Pakistan (‫پاکستان‬‎)',
    iso: 'PK',
    dialCode: '92',
    typeahead: 'Pakistan (‫پاکستان‬‎) +92'
  },
  {
    name: 'Palau',
    iso: 'PW',
    dialCode: '680',
    typeahead: 'Palau +680'
  },
  {
    name: 'Palestine (‫فلسطين‬‎)',
    iso: 'PS',
    dialCode: '970',
    typeahead: 'Palestine (‫فلسطين‬‎) +970'
  },
  {
    name: 'Panama (Panamá)',
    iso: 'PA',
    dialCode: '507',
    typeahead: 'Panama (Panamá) +507'
  },
  {
    name: 'Papua New Guinea',
    iso: 'PG',
    dialCode: '675',
    typeahead: 'Papua New Guinea +675'
  },
  {
    name: 'Paraguay',
    iso: 'PY',
    dialCode: '595',
    typeahead: 'Paraguay +595'
  },
  {
    name: 'Peru (Perú)',
    iso: 'PE',
    dialCode: '51',
    typeahead: 'Peru (Perú) +51'
  },
  {
    name: 'Philippines',
    iso: 'PH',
    dialCode: '63',
    typeahead: 'Philippines +63'
  },
  {
    name: 'Poland (Polska)',
    iso: 'PL',
    dialCode: '48',
    typeahead: 'Poland (Polska) +48'
  },
  {
    name: 'Portugal',
    iso: 'PT',
    dialCode: '351',
    typeahead: 'Portugal +351'
  },
  {
    name: 'Puerto Rico',
    iso: 'PR',
    dialCode: '1',
    typeahead: 'Puerto Rico +1'
  },
  {
    name: 'Qatar (‫قطر‬‎)',
    iso: 'QA',
    dialCode: '974',
    typeahead: 'Qatar (‫قطر‬‎) +974'
  },
  {
    name: 'Réunion (La Réunion)',
    iso: 'RE',
    dialCode: '262',
    typeahead: 'Réunion (La Réunion) +262'
  },
  {
    name: 'Romania (România)',
    iso: 'RO',
    dialCode: '40',
    typeahead: 'Romania (România) +40'
  },
  {
    name: 'Russia (Россия)',
    iso: 'RU',
    dialCode: '7',
    typeahead: 'Russia (Россия) +7'
  },
  {
    name: 'Rwanda',
    iso: 'RW',
    dialCode: '250',
    typeahead: 'Rwanda +250'
  },
  {
    name: 'Saint Barthélemy',
    iso: 'BL',
    dialCode: '590',
    typeahead: 'Saint Barthélemy +590'
  },
  {
    name: 'Saint Helena',
    iso: 'SH',
    dialCode: '290',
    typeahead: 'Saint Helena +290'
  },
  {
    name: 'Saint Kitts and Nevis',
    iso: 'KN',
    dialCode: '1',
    typeahead: 'Saint Kitts and Nevis +1'
  },
  {
    name: 'Saint Lucia',
    iso: 'LC',
    dialCode: '1',
    typeahead: 'Saint Lucia +1'
  },
  {
    name: 'Saint Martin (Saint-Martin (partie française))',
    iso: 'MF',
    dialCode: '590',
    typeahead: 'Saint Martin (Saint-Martin (partie française)) +590'
  },
  {
    name: 'Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)',
    iso: 'PM',
    dialCode: '508',
    typeahead: 'Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon) +508'
  },
  {
    name: 'Saint Vincent and the Grenadines',
    iso: 'VC',
    dialCode: '1',
    typeahead: 'Saint Vincent and the Grenadines +1'
  },
  {
    name: 'Samoa',
    iso: 'WS',
    dialCode: '685',
    typeahead: 'Samoa +685'
  },
  {
    name: 'San Marino',
    iso: 'SM',
    dialCode: '378',
    typeahead: 'San Marino +378'
  },
  {
    name: 'São Tomé and Príncipe (São Tomé e Príncipe)',
    iso: 'ST',
    dialCode: '239',
    typeahead: 'São Tomé and Príncipe (São Tomé e Príncipe) +239'
  },
  {
    name: 'Saudi Arabia (‫المملكة العربية السعودية‬‎)',
    iso: 'SA',
    dialCode: '966',
    typeahead: 'Saudi Arabia (‫المملكة العربية السعودية‬‎) +966'
  },
  {
    name: 'Senegal (Sénégal)',
    iso: 'SN',
    dialCode: '221',
    typeahead: 'Senegal (Sénégal) +221'
  },
  {
    name: 'Serbia (Србија)',
    iso: 'RS',
    dialCode: '381',
    typeahead: 'Serbia (Србија) +381'
  },
  {
    name: 'Seychelles',
    iso: 'SC',
    dialCode: '248',
    typeahead: 'Seychelles +248'
  },
  {
    name: 'Sierra Leone',
    iso: 'SL',
    dialCode: '232',
    typeahead: 'Sierra Leone +232'
  },
  {
    name: 'Singapore',
    iso: 'SG',
    dialCode: '65',
    typeahead: 'Singapore +65'
  },
  {
    name: 'Sint Maarten',
    iso: 'SX',
    dialCode: '1',
    typeahead: 'Sint Maarten +1'
  },
  {
    name: 'Slovakia (Slovensko)',
    iso: 'SK',
    dialCode: '421',
    typeahead: 'Slovakia (Slovensko) +421'
  },
  {
    name: 'Slovenia (Slovenija)',
    iso: 'SI',
    dialCode: '386',
    typeahead: 'Slovenia (Slovenija) +386'
  },
  {
    name: 'Solomon Islands',
    iso: 'SB',
    dialCode: '677',
    typeahead: 'Solomon Islands +677'
  },
  {
    name: 'Somalia (Soomaaliya)',
    iso: 'SO',
    dialCode: '252',
    typeahead: 'Somalia (Soomaaliya) +252'
  },
  {
    name: 'South Africa',
    iso: 'ZA',
    dialCode: '27',
    typeahead: 'South Africa +27'
  },
  {
    name: 'South Korea (대한민국)',
    iso: 'KR',
    dialCode: '82',
    typeahead: 'South Korea (대한민국) +82'
  },
  {
    name: 'South Sudan (‫جنوب السودان‬‎)',
    iso: 'SS',
    dialCode: '211',
    typeahead: 'South Sudan (‫جنوب السودان‬‎) +211'
  },
  {
    name: 'Spain (España)',
    iso: 'ES',
    dialCode: '34',
    typeahead: 'Spain (España) +34'
  },
  {
    name: 'Sri Lanka (ශ්‍රී ලංකාව)',
    iso: 'LK',
    dialCode: '94',
    typeahead: 'Sri Lanka (ශ්‍රී ලංකාව) +94'
  },
  {
    name: 'Sudan (‫السودان‬‎)',
    iso: 'SD',
    dialCode: '249',
    typeahead: 'Sudan (‫السودان‬‎) +249'
  },
  {
    name: 'Suriname',
    iso: 'SR',
    dialCode: '597',
    typeahead: 'Suriname +597'
  },
  {
    name: 'Svalbard and Jan Mayen',
    iso: 'SJ',
    dialCode: '47',
    typeahead: 'Svalbard and Jan Mayen +47'
  },
  {
    name: 'Sweden (Sverige)',
    iso: 'SE',
    dialCode: '46',
    typeahead: 'Sweden (Sverige) +46'
  },
  {
    name: 'Switzerland (Schweiz)',
    iso: 'CH',
    dialCode: '41',
    typeahead: 'Switzerland (Schweiz) +41'
  },
  {
    name: 'Syria (‫سوريا‬‎)',
    iso: 'SY',
    dialCode: '963',
    typeahead: 'Syria (‫سوريا‬‎) +963'
  },
  {
    name: 'Taiwan (台灣)',
    iso: 'TW',
    dialCode: '886',
    typeahead: 'Taiwan (台灣) +886'
  },
  {
    name: 'Tajikistan',
    iso: 'TJ',
    dialCode: '992',
    typeahead: 'Tajikistan +992'
  },
  {
    name: 'Tanzania',
    iso: 'TZ',
    dialCode: '255',
    typeahead: 'Tanzania +255'
  },
  {
    name: 'Thailand (ไทย)',
    iso: 'TH',
    dialCode: '66',
    typeahead: 'Thailand (ไทย) +66'
  },
  {
    name: 'Timor-Leste',
    iso: 'TL',
    dialCode: '670',
    typeahead: 'Timor-Leste +670'
  },
  {
    name: 'Togo',
    iso: 'TG',
    dialCode: '228',
    typeahead: 'Togo +228'
  },
  {
    name: 'Tokelau',
    iso: 'TK',
    dialCode: '690',
    typeahead: 'Tokelau +690'
  },
  {
    name: 'Tonga',
    iso: 'TO',
    dialCode: '676',
    typeahead: 'Tonga +676'
  },
  {
    name: 'Trinidad and Tobago',
    iso: 'TT',
    dialCode: '1',
    typeahead: 'Trinidad and Tobago +1'
  },
  {
    name: 'Tunisia (‫تونس‬‎)',
    iso: 'TN',
    dialCode: '216',
    typeahead: 'Tunisia (‫تونس‬‎) +216'
  },
  {
    name: 'Turkey (Türkiye)',
    iso: 'TR',
    dialCode: '90',
    typeahead: 'Turkey (Türkiye) +90'
  },
  {
    name: 'Turkmenistan',
    iso: 'TM',
    dialCode: '993',
    typeahead: 'Turkmenistan +993'
  },
  {
    name: 'Turks and Caicos Islands',
    iso: 'TC',
    dialCode: '1',
    typeahead: 'Turks and Caicos Islands +1'
  },
  {
    name: 'Tuvalu',
    iso: 'TV',
    dialCode: '688',
    typeahead: 'Tuvalu +688'
  },
  {
    name: 'U.S. Virgin Islands',
    iso: 'VI',
    dialCode: '1',
    typeahead: 'U.S. Virgin Islands +1'
  },
  {
    name: 'Uganda',
    iso: 'UG',
    dialCode: '256',
    typeahead: 'Uganda +256'
  },
  {
    name: 'Ukraine (Україна)',
    iso: 'UA',
    dialCode: '380',
    typeahead: 'Ukraine (Україна) +380'
  },
  {
    name: 'United Arab Emirates (‫الإمارات العربية المتحدة‬‎)',
    iso: 'AE',
    dialCode: '971',
    typeahead: 'United Arab Emirates (‫الإمارات العربية المتحدة‬‎) +971'
  },
  {
    name: 'United Kingdom',
    iso: 'GB',
    dialCode: '44',
    typeahead: 'United Kingdom +44'
  },
  {
    name: 'United States',
    iso: 'US',
    dialCode: '1',
    typeahead: 'United States +1'
  },
  {
    name: 'Uruguay',
    iso: 'UY',
    dialCode: '598',
    typeahead: 'Uruguay +598'
  },
  {
    name: 'Uzbekistan (Oʻzbekiston)',
    iso: 'UZ',
    dialCode: '998',
    typeahead: 'Uzbekistan (Oʻzbekiston) +998'
  },
  {
    name: 'Vanuatu',
    iso: 'VU',
    dialCode: '678',
    typeahead: 'Vanuatu +678'
  },
  {
    name: 'Vatican City (Città del Vaticano)',
    iso: 'VA',
    dialCode: '39',
    typeahead: 'Vatican City (Città del Vaticano) +39'
  },
  {
    name: 'Venezuela',
    iso: 'VE',
    dialCode: '58',
    typeahead: 'Venezuela +58'
  },
  {
    name: 'Vietnam (Việt Nam)',
    iso: 'VN',
    dialCode: '84',
    typeahead: 'Vietnam (Việt Nam) +84'
  },
  {
    name: 'Wallis and Futuna (Wallis-et-Futuna)',
    iso: 'WF',
    dialCode: '681',
    typeahead: 'Wallis and Futuna (Wallis-et-Futuna) +681'
  },
  {
    name: 'Western Sahara (‫الصحراء الغربية‬‎)',
    iso: 'EH',
    dialCode: '212',
    typeahead: 'Western Sahara (‫الصحراء الغربية‬‎) +212'
  },
  {
    name: 'Yemen (‫اليمن‬‎)',
    iso: 'YE',
    dialCode: '967',
    typeahead: 'Yemen (‫اليمن‬‎) +967'
  },
  {
    name: 'Zambia',
    iso: 'ZM',
    dialCode: '260',
    typeahead: 'Zambia +260'
  },
  {
    name: 'Zimbabwe',
    iso: 'ZW',
    dialCode: '263',
    typeahead: 'Zimbabwe +263'
  },
  {
    name: 'Åland Islands',
    iso: 'AX',
    dialCode: '358',
    typeahead: 'Åland Islands +358'
  }
];

export default countryPhone;